import { DoubleRangeSlider } from 'components/DoubleRangeSlider/DoubleRangeSlider';

type Props = {
  title: string;
  currentMinValue: number;
  currentMaxValue: number;
  minValue: number;
  maxValue: number;
  onSliderChange: (e: Event, values: number | number[]) => void;
  onMinChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FilterItem: React.FC<Props> = props => {
  const {
    currentMinValue,
    currentMaxValue,
    minValue,
    maxValue,
    onSliderChange,
    onMinChange,
    onMaxChange,
    title,
  } = props;

  return (
    <>
      <label className="block font-medium mb-2">{title}</label>

      <DoubleRangeSlider
        minValue={minValue}
        maxValue={maxValue}
        currentMinValue={currentMinValue}
        currentMaxValue={currentMaxValue}
        onChange={onSliderChange}
      />

      <div className="flex text-sm mt-0 gap-2">
        <input
          type="text"
          value={currentMinValue}
          className="w-1/2 bg-blue-light dark:bg-blue-darkMode-30 p-2 rounded-8 outline-none active:bg-blue-light-20 focus:bg-blue-light-20 hover:bg-blue-light-10"
          onChange={onMinChange}
        />
        <input
          type="text"
          value={currentMaxValue}
          className="w-1/2 bg-blue-light dark:bg-blue-darkMode-30 p-2 rounded-8 outline-none active:bg-blue-light-20 focus:bg-blue-light-20 hover:bg-blue-light-10"
          onChange={onMaxChange}
        />
      </div>
    </>
  );
};
